export default __webpack_public_path__ + "static/media/usdt_pol.2c0ddebb.svg";